import axios from 'axios';
import { Dispatch } from 'redux';
import { errorHandler } from 'services/axiosService';

import { responseEntityMapper, responseListMapper } from '@qwealth/qcore';
import { REACT_APP_QWEALTH_API_V3 } from '@qwealth/qdata';

import { NewWorkflowTemplate, WorkflowTemplate, WorkflowTemplateFilters } from 'data/models/WorkflowTemplates';

export const fetchWorkflowTemplates = async (partnerId: number, dispatch: Dispatch, iaCode?: string | null): Promise<WorkflowTemplate[]> => {
  try {
    const filters: WorkflowTemplateFilters = { partnerId, iaCode };
    const response = await axios.get(`${REACT_APP_QWEALTH_API_V3}/workflowTemplate`, { params: filters });
    return responseListMapper<WorkflowTemplate>(response);
  } catch (e) {
    errorHandler(dispatch, 'API Error: Failed Fetching Workflow Templates')(e);
    return [];
  }
};

export const postWorkflowTemplate = async (workflowTemplate: NewWorkflowTemplate, dispatch: Dispatch): Promise<WorkflowTemplate | undefined> => {
  try {
    const response = await axios.post(`${REACT_APP_QWEALTH_API_V3}/workflowTemplate`, workflowTemplate);
    return responseEntityMapper(response);
  } catch (e) {
    errorHandler(dispatch, `API Error: Failed posting a Workflow Template: ${workflowTemplate.name}`)(e);
    return undefined;
  }
};

export const patchWorkflowTemplate = async (workflowTemplate: WorkflowTemplate, dispatch: Dispatch): Promise<WorkflowTemplate | undefined> => {
  try {
    const response = await axios.patch(`${REACT_APP_QWEALTH_API_V3}/workflowTemplate/${workflowTemplate.id}`, workflowTemplate);
    return responseEntityMapper(response);
  } catch (e) {
    errorHandler(dispatch, `API Error: Failed updating Workflow Template: ${workflowTemplate.name}`)(e);
    return undefined;
  }
};

export const deleteWorkflowTemplate = async (workflowTemplateId: number, dispatch: Dispatch): Promise<number | undefined> => {
  try {
    const response = await axios.delete(`${REACT_APP_QWEALTH_API_V3}/workflowTemplate/${workflowTemplateId}`);
    return responseEntityMapper(response);
  } catch (e) {
    errorHandler(dispatch, 'API Error: Failed Deleting Workflow Template')(e);
    return undefined;
  }
};
